/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListSignersResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'Signer',
        },
        isRequired: true,
      },
    },
  }],
} as const;
